import { render, staticRenderFns } from "./ViewAllProducts.vue?vue&type=template&id=22fd1edc&"
import script from "./ViewAllProducts.vue?vue&type=script&lang=js&"
export * from "./ViewAllProducts.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports